<h2>Financial Quater Report</h2>


<div>
    <div>Total Sales (G1): {{profitTotal | human}}</div>
    <div>GST on Sales (1A): {{profitVATtotal | human}}</div>
    <div>GST on Purchases (1B): {{expenseVATtotal | human}}</div>
</div>

<a target="_blank" href="https://onlineservices.ato.gov.au/business/" mat-raised-button>ATO Online Services</a>